import type { ReactNode } from "react";
import { TableCell, TableRow } from "@mui/material";

type Props = {
  label: string;
  value: ReactNode;
};

export function FieldRow({ label, value }: Props) {
  return (
    <TableRow>
      <TableCell
        sx={{
          width: "40%",
          color: "text.secondary",
          fontSize: 13,
          borderColor: "#E0E4EF",
          verticalAlign: "top",
        }}
      >
        {label}
      </TableCell>
      <TableCell
        sx={{
          fontSize: 13,
          fontWeight: 500,
          borderColor: "#E0E4EF",
          whiteSpace: "pre-line",
        }}
      >
        {value}
      </TableCell>
    </TableRow>
  );
}

export default FieldRow;
